import React from 'react'
import { Button } from 'react-bootstrap'
import { BsExclamationCircle } from 'react-icons/bs'

const ErrorState = ({
    title = "Something went wrong",
    message = "We couldn't load the data. Please try again.",
    onRetry = null,
    retryText = "Refresh"
}) => {
    return (
        <div className="d-flex justify-content-center align-items-center py-5">
            <div className="text-center">
                {/* Error Icon */}
                <BsExclamationCircle
                    className="text-muted mb-3"
                    size={48}
                />

                {/* Title */}
                <h5 className="text-dark fw-bold mb-2">
                    {title}
                </h5>

                {/* Message */}
                <p className="text-muted mb-4">
                    {message}
                </p>

                {/* Refresh Button */}
                {onRetry && (
                    <Button
                        variant="outline-dark"
                        onClick={onRetry}
                        className="rounded-pill px-4 border-2"
                        style={{
                            borderColor: '#000000ff',
                            color: '#000000ff',
                            backgroundColor: 'transparent',
                            transition: 'all 0.2s ease-in-out'
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#ffffffff';
                            e.target.style.color = '#000000ff';
                            e.target.style.borderColor = '#000000ff';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'transparent';
                            e.target.style.color = '#000000ff';
                            e.target.style.borderColor = '#000000ff';
                        }}
                    >
                        {retryText}
                    </Button>
                )}
            </div>
        </div>
    )
}

export default ErrorState